export const hasCustomerId = (client: { id?: string | null } | undefined) => {
  const id = client?.id;
  const result = Boolean(id && id !== 'unkown');

  return result;
};

export const getCustomerLogoFile = (client?: {
  logo?: string | null;
  id?: string | null;
}) => {
  if (hasCustomerId(client) && client?.logo) {
    return `clients/${client.logo}`;
  }
  return '';
};
